import { Form, FormProps, message } from 'antd';
import { BottomButton, BottomFooter, FormContainer } from './styles';
import { StoreInfo } from './StoreInfo';
import CheckboxGroup, { CheckboxGroupOption } from './CheckboxGroup';
import { useState } from 'react';
import { useTranslate } from '@tolgee/react';
import { ShopeeAuthShopParams, ShopeeAuthWay } from './ShopeeShopAuthWay';
import { ShopTypeEnum } from './ShopeeCNSCGuide';
import { useMemoizedFn } from 'ahooks';
import { RightOutlined } from '@ant-design/icons';

interface QuickChatShopeeAuthProps {
  form: FormProps['form'];
  shopeeAuthWay?: ShopeeAuthWay;
  shopeeAuthParams?: ShopeeAuthShopParams;
  onChange?: (value: ShopeeAuthWay) => void;
  onNext?: (value: any) => void;
}

export const QuickChatShopeeAuth = (props: QuickChatShopeeAuthProps) => {
  const { form, shopeeAuthWay, shopeeAuthParams, onChange, onNext } = props;
  const { t } = useTranslate();
  const [authWayOptions, setAuthWayOptions] = useState<CheckboxGroupOption[]>([]);

  /**
   * 初始化授权方式选项
   * PD: https://leyan.yuque.com/czpqnb/pd/ohezvbqx9qkd9c33#ikLAI
   */
  const initAuthWayOptions = useMemoizedFn(() => {
    let options: CheckboxGroupOption[] = [];
    const shopType = form?.getFieldValue('shopType');
    // 本土店铺
    if (shopType === ShopTypeEnum.Local) {
      options = [
        {
          render: t('authShop.authWayOption3'),
          value: ShopeeAuthWay.Official,
        },
        {
          render: t('authShop.authWayOption5'),
          value: ShopeeAuthWay.External,
        },
      ];
    }

    // 跨境店铺 (官方仓)
    if (shopType === ShopTypeEnum.CrossOfficial) {
      options = [
        {
          render: t('authShop.authWayOption4'),
          value: ShopeeAuthWay.Official,
        },
        {
          render: t('authShop.authWayOption6'),
          value: ShopeeAuthWay.External,
        },
      ];
    }

    // 3PF店铺 (第三方仓)
    if (shopType === ShopTypeEnum.Cross3PF) {
      options = [
        {
          render: t('authShop.authWayOption3'),
          value: ShopeeAuthWay.Official,
        },
        {
          render: t('authShop.authWayOption5'),
          value: ShopeeAuthWay.External,
        },
      ];
    }

    setAuthWayOptions(options);

    const authWay = shopeeAuthWay ? shopeeAuthWay : (options?.[0]?.value as ShopeeAuthWay);
    form?.setFieldsValue({ authWay });

    requestAnimationFrame(() => {
      onChange?.(authWay);
    });
  });

  return (
    <FormContainer layout="vertical" form={form}>
      <Form.Item label={t('authShop.店铺信息')} required>
        <StoreInfo
          form={form}
          shopeeAuthParams={shopeeAuthParams}
          onChange={(values) => {
            form?.setFieldsValue(values);
            initAuthWayOptions();
          }}
        />
      </Form.Item>

      <Form.Item label={t('authShop.您可选择以下任意方式添加店铺')} name="authWay" required>
        <CheckboxGroup
          layout="vertical"
          options={authWayOptions}
          onChange={(val) => onChange && onChange(val as ShopeeAuthWay)}
        />
      </Form.Item>

      <BottomFooter>
        <BottomButton
          size="large"
          type="primary"
          onClick={() => {
            const storeType = form?.getFieldValue('storeType');
            const region = form?.getFieldValue('region');
            const shopType = form?.getFieldValue('shopType');
            if (!region || !storeType) {
              message.warning(t('auth.shopee.store.info.miss.warning'));
              return;
            }

            if (onNext && storeType && region) {
              onNext &&
                onNext({
                  shopType,
                  storeType,
                  region,
                  account: form?.getFieldValue('account'),
                  password: form?.getFieldValue('password'),
                  departmentIds: form?.getFieldValue('departmentIds'),
                });
            }
          }}
        >
          {t('authShop.下一步')}
          <RightOutlined />
        </BottomButton>
      </BottomFooter>
    </FormContainer>
  );
};
